//时间格式化
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    'S': this.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

function ymtDateFormat (fmt, str) {
  var retxt = ''
  if (str != undefined && str != '') {
    retxt = new Date(str).Format(fmt)
  } else {
    retxt = new Date().Format(fmt)
  }
  return retxt
}

//获取上月月份
function ymtLastMonth(fmt) {
  var issymbol = ''
  var y = '' //获取当前日期的年份
  var m = '' //获取当前日期的月份

  if (fmt.indexOf('-') > -1) {
    issymbol = '-'
    var arr = fmt.split('-')
    y = arr[0] //获取当前日期的年份
    m = arr[1] //获取当前日期的月份
  } else {
    y = fmt.substr(0, 4) //获取当前日期的年份
    m = fmt.substr(4, 2) //获取当前日期的月份
  }

  var nextY = y
  var nextM = m
  if (parseInt(m) - 1 > 0) {
    nextM = parseInt(m) - 1
    nextM = nextM < 10 ? ('0' + nextM) : nextM

  } else {
    nextY = y - 1
    nextM = 12
  }
  return nextY + issymbol + nextM
}

//获取下月月份
function ymtNextMonth(fmt) {
  var issymbol = ''
  var y = '' //获取当前日期的年份
  var m = '' //获取当前日期的月份

  if (fmt.indexOf('-') > -1) {
    issymbol = '-'
    var arr = fmt.split('-')
    y = arr[0] //获取当前日期的年份
    m = arr[1] //获取当前日期的月份
  } else {
    y = fmt.substr(0, 4) //获取当前日期的年份
    m = fmt.substr(4, 2) //获取当前日期的月份
  }

  var nextY = y
  var nextM = m
  if (parseInt(m) + 1 < 13) {
    nextM = parseInt(m) + 1
    nextM = nextM < 10 ? ('0' + nextM) : nextM
  } else {
    nextY = parseInt(y) + 1
    nextM = '01'
  }
  return nextY + issymbol + nextM
}

const axios = require("axios");
//时间加一天
function addDate(date, days) {
    if (days == undefined || days == '') {
        days = 1;
    }
    var date = new Date(date);
    date.setDate(date.getDate() + days);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return date.getFullYear() + '-' + getFormatDate(month) + '-' + getFormatDate(day);
}
function getFormatDate(arg) {
    if (arg == undefined || arg == '') {
        return '';
    }

    var re = arg + '';
    if (re.length < 2) {
        re = '0' + re;
    }

    return re;
}
// 获取当前日期的上一个月
 function getlastMonth() {
    let now = new Date();
    // 当前月的日期
    let nowDate = now.getDate();
    let lastMonth = new Date(now.getTime());
    // 设置上一个月（这里不需要减1）
    lastMonth.setMonth(lastMonth.getMonth());
    // 设置为0，默认为当前月的最后一天
    lastMonth.setDate(0);
    // 上一个月的天数
    let daysOflastMonth = lastMonth.getDate();
    // 设置上一个月的日期，如果当前月的日期大于上个月的总天数，则为最后一天 
    lastMonth.setDate(nowDate > daysOflastMonth ? daysOflastMonth : nowDate);
    return lastMonth;
}
// 获取当天日期
function getDateTime  (type){
    // 获取当前日期
    let timestamp = Date.parse(new Date());
    let date = new Date(timestamp);
    if (type == 'tomorrow') { // 明天
        date.setDate(date.getDate() + 1);

    } else if (type == 'today') { // 今天
        date.setDate(date.getDate());
    }
    //获取年份  
    var Y = date.getFullYear();
    //获取月份  
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    //获取当日日期 
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let todayDate = Y + '-' + M + '-' + D;
    return todayDate
};
//获取当月一号
function getNowMonthFirst() {
              var date = new Date();
              date.setDate(1);
              var cTime = new Date(new Date(date).toLocaleDateString()).getTime();
              //将时间戳转换成时间格式
              var date1 = new Date(cTime);
              var year = date1.getFullYear();
              var month = date1.getMonth() + 1;
              var day = date1.getDate();
              month = month < 10 ? "0" + month : month;
              day = day < 10 ? "0" + day : day;
              var ddate = year + '-' + month + '-' + day;
              return ddate;
}
//获取最近的6个月日期
function getbeforeTime() {
  var timeArray = [];
  for (let i = 0; i <= 5; i++){
     let date = new Date()
      date.setMonth(date.getMonth() - (5-i))
      date.toLocaleDateString()
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      timeArray.push(y +"年" + m+ "月") 
  }
  return timeArray;
}
export default {
  ymtDateFormat,
  ymtLastMonth,
  ymtNextMonth,
  addDate,
  getDateTime,
  getlastMonth,
  getNowMonthFirst,
  getbeforeTime
}




// WEBPACK FOOTER //
// ./src/utils/common.js